import { ReactNode, ElementType, DetailedHTMLProps, HTMLAttributes } from 'react';
import url from '@/utils/config';

type Props = {
  as: ElementType<DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>>;
  icon?: string;
  children: ReactNode;
  // eslint-disable-next-line react/require-default-props
  className?: string;
};

/**
 * 見出しレベルとアイコン表現を統一する共通見出しコンポーネント。
 * @param props 見出しタグ、アイコン、表示文字列
 * @returns 見出し表示
 */
const Heading = ({ as: Tag, icon = undefined, children, className = '' }: Props) => {
  // h1/h2... のタグ名末尾から BEM クラスを組み立て、見出しレベルごとの見た目を揃える。
  const headingClass = `m-heading-l${Tag.toString().slice(-1)}`;
  return (
    <div className={headingClass}>
      <Tag className={`${headingClass}__hdg${className ? ` ${className}` : ''}`}>
        {/* アイコン指定時だけ装飾画像を付け、テキスト見出しとの共通利用を両立する。 */}
        {icon && (
          <img className={`${headingClass}__hdgImg`} src={url(`/images/icon_${icon}.svg`)} alt='' />
        )}
        {children}
      </Tag>
    </div>
  );
};

export default Heading;
